(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dealbyte-tech-journal"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('dealbyte-tech-journal')) {
    customElements.define('dealbyte-tech-journal', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = {signal: this.controller.signal};
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        this.related = Array.from(this.querySelectorAll('[data-related]'));
        this.stage = this.querySelector('[data-stage]');
        if (!this.tabs.length || !this.stage) return;
        this.index = 0;
        this.setAttribute('data-ready', '');
        this.activate = (index, focus = false, announce = true) => {
          this.index = (index + this.tabs.length) % this.tabs.length;
          const active = this.tabs[this.index];
          this.tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === this.index)); tab.tabIndex = i === this.index ? 0 : -1;});
          this.panels.forEach(panel => {panel.hidden = panel.dataset.panel !== active.dataset.tab;});
          const poster = this.panels[this.index].querySelector('.db-journal__photo');
          if (poster?.loading === 'lazy') poster.loading = 'eager';
          this.related.forEach(item => {item.hidden = item.dataset.related !== active.dataset.tab;});
          const select = this.querySelector('[data-brand-select]');
          if (select) select.value = active.dataset.tab;
          this.querySelector('[data-current]').textContent = String(this.index + 1).padStart(2, '0');
          if (focus) active.focus({preventScroll: true});
          const rail = active.parentElement;
          const delta = active.offsetLeft - rail.offsetLeft;
          if (delta < rail.scrollLeft || delta + active.offsetWidth > rail.scrollLeft + rail.clientWidth) rail.scrollTo({left: Math.max(0, delta - (rail.clientWidth - active.offsetWidth) / 2), behavior: 'auto'});
          if (announce) this.querySelector('[data-status]').textContent = active.querySelector('strong').textContent + '. ' + this.panels[this.index].querySelector('h3').textContent;
        };
        this.querySelector('[data-brand-select]')?.addEventListener('change', e => {
          const index = this.tabs.findIndex(tab => tab.dataset.tab === e.target.value);
          if (index >= 0) this.activate(index);
        }, options);
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', e => {e.preventDefault();this.activate(i);}, options);
          tab.addEventListener('keydown', e => {
            let index;
            if (e.key === 'ArrowRight') index = this.index + 1;
            if (e.key === 'ArrowLeft') index = this.index - 1;
            if (e.key === 'Home') index = 0;
            if (e.key === 'End') index = this.tabs.length - 1;
            if (index !== undefined) {e.preventDefault();this.activate(index, true);}
          }, options);
        });
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.activate(this.index + Number(button.dataset.step)), options));
        let start;
        let blockClickUntil = 0;
        this.stage.addEventListener('pointerdown', e => {if (e.isPrimary && e.pointerType !== 'mouse') start = {x:e.clientX,y:e.clientY};}, options);
        this.stage.addEventListener('pointerup', e => {
          if (!start) return;
          const dx = e.clientX - start.x;
          const dy = e.clientY - start.y;
          start = null;
          if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {blockClickUntil = performance.now() + 400;this.activate(this.index + (dx < 0 ? 1 : -1));}
        }, options);
        this.stage.addEventListener('pointercancel', () => {start = null;}, options);
        this.stage.addEventListener('click', e => {if (performance.now() < blockClickUntil) {e.preventDefault();e.stopPropagation();}}, {...options,capture:true});
        this.addEventListener('shopify:block:select', e => {
          const panel = e.target.closest('[data-panel]');
          const index = this.tabs.findIndex(tab => tab.dataset.tab === panel?.dataset.panel);
          if (index >= 0) this.activate(index);
        }, options);
        this.activate(0, false, false);
      }
      disconnectedCallback() {this.controller?.abort();}
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
